import React, { Component } from 'react'
import './Mag.css';

import img1 from '../assets/issue_17/001.jpg'
import img2 from '../assets/issue_17/002.jpg'
import img3 from '../assets/issue_17/003.jpg'
import img4 from '../assets/issue_17/004.jpg'
import img5 from '../assets/issue_17/005.jpg'
import img6 from '../assets/issue_17/006.jpg'
import img7 from '../assets/issue_17/007.jpg'
import img8 from '../assets/issue_17/008.jpg'
import img9 from '../assets/issue_17/009.jpg'
import img10 from '../assets/issue_17/010.jpg'
import img11 from '../assets/issue_17/011.jpg'
import img12 from '../assets/issue_17/012.jpg'
import img13 from '../assets/issue_17/013.jpg'
import img14 from '../assets/issue_17/014.jpg'
import img15 from '../assets/issue_17/015.jpg'
import img16 from '../assets/issue_17/016.jpg'
import img17 from '../assets/issue_17/017.jpg'
import img18 from '../assets/issue_17/018.jpg'
import img19 from '../assets/issue_17/019.jpg'
import img20 from '../assets/issue_17/020.jpg'
import img21 from '../assets/issue_17/021.jpg'
import img22 from '../assets/issue_17/022.jpg'
import img23 from '../assets/issue_17/023.jpg'
import img24 from '../assets/issue_17/024.jpg'
import img25 from '../assets/issue_17/025.jpg'
import img26 from '../assets/issue_17/026.jpg'
import img27 from '../assets/issue_17/027.jpg'
import img28 from '../assets/issue_17/028.jpg'
import img29 from '../assets/issue_17/029.jpg'
import img30 from '../assets/issue_17/030.jpg'
import img31 from '../assets/issue_17/031.jpg'


export default class Mag015 extends Component {
  render() {
    return (
      <div className="image-container">
        <img src={img1} className="image"></img>
        <img src={img2} className="image"></img>
        <img src={img3} className="image"></img>
        <img src={img4} className="image"></img>
        <img src={img5} className="image"></img>
        <img src={img6} className="image"></img>
        <img src={img7} className="image"></img>
        <img src={img8} className="image"></img>
        <img src={img9} className="image"></img>
        <img src={img10} className="image"></img>
        <img src={img11} className="image"></img>
        <img src={img12} className="image"></img>
        <img src={img13} className="image"></img>
        <img src={img14} className="image"></img>
        <img src={img15} className="image"></img>
        <img src={img16} className="image"></img>
        <img src={img17} className="image"></img>
        <img src={img18} className="image"></img>
        <img src={img19} className="image"></img>
        <img src={img20} className="image"></img>
        <img src={img21} className="image"></img>
        <img src={img22} className="image"></img>
        <img src={img23} className="image"></img>
        <img src={img24} className="image"></img>
        <img src={img25} className="image"></img>
        <img src={img26} className="image"></img>
        <img src={img27} className="image"></img>
        <img src={img28} className="image"></img>
        <img src={img29} className="image"></img>
        <img src={img30} className="image"></img>
        <img src={img31} className="image"></img>
      </div>
    )
  }
}
